import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationExtras } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  NgForm,
  Validators,
  FormControl,
} from "@angular/forms";

import { UserService } from "../services/user.service";
import { DataSharingService } from "../services/data-sharing.service";
import { LocationService } from "../services/location.service";
import { ClassScheduleService } from "../services/class-schedule.service";
import { StudentService } from "../services/student.service";
import { InstructorService } from "../services/instructor.service";
import { ClassMasterService } from "../services/class-master.service";

import { LoginReq } from "../models/user";
import { CreateLogin } from "../models/create-login";
import { StudentList } from "../models/student-list";
import { StudentClassDto } from "../models/student-class-dto";
import { Location } from "../models/location";
import { AdminStudentSearchResult } from "../models/admin-student-search-result";
import { ClassSchedule } from "../models/class-schedule";
import { ClassMaster } from "../models/class-master";
import { Instructor } from "../models/instructor";
import { ClassScheduleDto } from "../models/class-schedule-dto";
import { AddressList } from "../models/address-list";
import { AddressGet } from "../models/address-get";
import { Setting } from "../models/settings";
import { StudentGet } from "../models/student-get";
import { StudentPost } from "../models/student-post";
import { Mhsrcuser } from "../models/user";

@Component({
  selector: "staff-registration",
  templateUrl: "./staff-registration.component.html",
  styleUrls: ["./staff-registration.component.css"],
})
export class StaffRegistrationComponent implements OnInit {
  login: LoginReq = new LoginReq();
  instructor: Instructor = new Instructor();
  searchmsg = "";
  savemsg = "";
  msg = "";
  isAdmin = true;
  isSuper = true;
  submitted = false;
  loading = false;
  searching = false;
  saving = false;
  isActive = true;
  passwordReset = false;
  showAdmins: boolean = false;
  isAuthenticated: boolean = false;
  doStudentSearch: boolean = false;
  doAdminSearch: boolean = false;
  editAdmin: boolean = false;
  createAdmin: boolean = false;
  showStdentClasses: boolean = false;
  showLocationList: boolean = false;
  readLocationList: boolean = false;
  showInstructorClasses: boolean = false;
  findInstructorClasses: boolean = false;
  studentsInClass: boolean = false;
  findStudentsInClass: boolean = false;
  enrollNew: boolean = false;
  showMenu: boolean = true;
  resultsFound: boolean = false;
  classResultsFound: boolean = false;
  adminResultsFound: boolean = false;
  displaySettings: boolean = false;
  searchString = "";
  displayModal: string = "none";
  searchResultsReturned: boolean = false;
  fullAddress: boolean = true;

  systemStatus: Setting = new Setting();
  setting4Hour: Setting = new Setting();
  setting8Hour: Setting = new Setting();
  emailAddress: Setting = new Setting();
  emailPassword: Setting = new Setting();
  emailServer: Setting = new Setting();
  emailPort: Setting = new Setting();
  classTypeId: string = "";
  loginId: string = "";
  password: string = "";
  adminUser: CreateLogin = new CreateLogin();
  studentUser: CreateLogin = new CreateLogin();
  student: StudentGet = new StudentGet();
  studentPost: StudentPost = new StudentPost();
  searchResults: StudentList[] = [];
  displayResults: StudentList[] = [];
  adminResults: Mhsrcuser[] = [];
  displayAdminResults: Mhsrcuser[] = [];
  studentClasses: StudentClassDto[] = [];
  instructorClasses: ClassScheduleDto[] = [];
  locations: Location[] = [];
  classSelected: ClassScheduleDto = new ClassScheduleDto();
  namesPerPage = 15;

  currentPageNumber: number = 1;
  totalPages: number;
  pages: any[] = [];

  selectedStudent: AdminStudentSearchResult;
  selectedClass: StudentClassDto;
  selectedAdmin: Mhsrcuser;
  newAdmin: Mhsrcuser;

  constructor(
    private _dataService: DataSharingService,
    private _router: Router,
    private _studentService: StudentService,
    private _classService: ClassScheduleService,
    private _locationService: LocationService,
    private _classMasterService: ClassMasterService,
    private _userService: UserService,
    private _instructorService: InstructorService
  ) {
    this.searchString = "";
    this.selectedStudent = new AdminStudentSearchResult();
    this.selectedClass = new StudentClassDto();
  }

  ngOnInit() {
    this.showAdmins = false;
    this.systemStatus.description = "normal";
    this.getSetting("System", "systemStatus");
    this.login.email = "";
    this.login.password = "";
    let adminUser = this._dataService.getCurrentUser();
    this.studentUser = null;
    this.student = null;
    // See if we're coming here after editing a student; if so, get the current student:
    if (
      adminUser != null &&
      adminUser.user != null &&
      adminUser.user.roleId == this._userService.roleStudent
    ) {
      this.studentUser = adminUser.user;
      const astudent = this._dataService.getCurrentStudent();
      if (astudent !== null && astudent.student !== null) {
        this.student = astudent.student;
      }
    }
    // See if this is a re-entrance after looking at another page; if so, get the admin/instructor:
    const roleId = this._dataService.getRoleId();
    if (
      roleId == this._userService.roleAdmin ||
      roleId == this._userService.roleSuper
    ) {
      adminUser = this._dataService.getAdminUser();
    }
    // clear flags:
    this.reset();
    this.getSettings();
    if (adminUser != null && adminUser.user != null) {
      if (
        adminUser.user.roleId == 0 + this._userService.roleAdmin ||
        adminUser.user.roleId == 0 + this._userService.roleSuper
      ) {
        // If this is an administrator, prepare:
        this.adminUser = adminUser.user;
        this.isAuthenticated = true;
        this.doStudentSearch = true;
        this._dataService.setCurrentUser(this.adminUser);
        // If we're coming in from a student edit, display past classes. Else display student search:
        if (this.student != null) {
          let foundStudent = new AdminStudentSearchResult();
          foundStudent.id = this.student.id;
          foundStudent.firstName = this.student.firstName;
          foundStudent.middleName = this.student.middleName;
          foundStudent.lastName = this.student.lastName;
          foundStudent.formattedName =
            this.student.firstName +
            " " +
            (this.student.middleName == null
              ? ""
              : this.student.middleName + " ") +
            this.student.lastName;
          // foundStudent.address = this.student.address;
          // foundStudent.address.formattedAddress = this.formataddressGet(this.student.address);
          foundStudent.phone = this.student.phone;
          foundStudent.cellPhone = this.student.cellPhone;
          foundStudent.email = this.student.email;
          this.goToStudentInfo(foundStudent);
        }
      } else if (this.adminUser.roleId === this._userService.roleInstructor) {
        // If this is an instructor, go to instructor page:
        this.isAuthenticated = true;
        this.getInstructor(this.adminUser.email);
      }
    }
  }

  logout() {
    this._dataService.logout();
    this._router.navigate(["/home"]);
  }

  // ------------------------------------------ Login ------------------------------------------ -->
  sendLogin(loginRequest: NgForm) {
    this.msg = "";
    this.submitted = true;
    if (loginRequest.dirty && loginRequest.valid) {
      // form is valid and dirty - send request'
      // this.submitted = true;
      this.loading = true;
      this._userService.login(this.login).subscribe(
        (res) => this.loginSuccessful(res),
        (error) => this.loginFailed(error),
        () => {
          console.log("Login successful!");
        }
      );
    }
  }

  loginFailed(error: any) {
    this.loading = false;
    console.log(error.message);
    this.msg = "Login failed! Invalid email or password."; // error.message;
  }

  loginSuccessful(res: any) {
    this.loading = false;
    this.adminUser = new CreateLogin();
    this.adminUser.id = res.current_user.id;
    this.adminUser.email = res.current_user.email;
    this.adminUser.firstName = res.current_user.firstName;
    this.adminUser.middleName = res.current_user.middleName;
    this.adminUser.lastName = res.current_user.lastName;
    this.adminUser.roleId = res.current_user.roleId;
    this.adminUser.password = this.login.password;
    this._dataService.setCurrentUser(this.adminUser);
    this._dataService.setAdminUser(this.adminUser);

    this._dataService.setAuthToken(res.auth_token);

    if (
      this.adminUser.roleId == this._userService.roleAdmin ||
      this.adminUser.roleId == this._userService.roleSuper
    ) {
      this.isAuthenticated = true;
      this.doStudentSearch = true;
      this.getSettings();
    } else if (this.adminUser.roleId == this._userService.roleInstructor) {
      this.isAuthenticated = true;
      this.getInstructor(this.adminUser.email);
    } else {
      this.msg = "Login failed! Invalid email or password."; // error.message;
    }
  }

  reset() {
    this.displaySettings = false;
    this.loading = false;
    this.showStdentClasses = false;
    this.classResultsFound = false;
    this.showLocationList = false;
    this.studentsInClass = false;
    this.findStudentsInClass = false;
    this.doStudentSearch = false;
    this.showInstructorClasses = false;
    this.findInstructorClasses = false;
    this.editAdmin = false;
    this.createAdmin = false;
    this.showAdmins = false;
    this.doAdminSearch = false;
    // this._dataService.setCurrentStudent(null);
  }
  // -- ------------------------------------------ Settings ------------------------------------------

  getSettings() {
    this.getSetting("Price", "price4Hour");
    this.getSetting("Price", "price8Hour");
    this.getSetting("Email", "emailAddress");
    this.getSetting("Email", "emailPassword");
    this.getSetting("Email", "emailServer");
    this.getSetting("Email", "emailPort");
  }

  saveSettings() {
    var valid4 = /^\d{2}(\.\d{2})?$/.test(this.setting4Hour.description);
    var valid8 = /^\d{2}(\.\d{2})?$/.test(this.setting8Hour.description);
    if (!valid4 || !valid8) {
      this.savemsg = "Invalid price(s).";
      setTimeout(() => {
        this.savemsg = "";
      }, 4000);
    } else {
      this.saveSetting(this.setting4Hour);
      this.saveSetting(this.setting8Hour);
      this.saveSetting(this.emailAddress);
      this.saveSetting(this.emailPassword);
      this.saveSetting(this.emailServer);
      this.saveSetting(this.emailPort);
      this.savemsg = "Settings saved.";
      setTimeout(() => {
        this.savemsg = "";
      }, 4000);
    }
  }

  getSetting(type: string, name: string) {
    this._dataService.getSetting(type, name).subscribe(
      (res) => this.getSettingSuccsess(res),
      (error) => this.settingFailure(error),
      () => console.log("Get " + name + " Complete!")
    );
  }
  saveSetting(setting: Setting) {
    this._dataService
      .updateSetting(setting.type, setting.name, setting.description)
      .subscribe(
        (res) => this.settingSuccsess(res),
        (error) => this.settingFailure(error),
        () => console.log("Update " + setting.name + " Complete!")
      );
  }

  getSettingSuccsess(result: any) {
    const setting = result[0] as Setting;
    this.settingSuccsess(setting);
  }
  settingSuccsess(result: any) {
    const setting = result as Setting;
    switch (setting.name) {
      case "systemStatus":
        this.systemStatus = setting;
        break;
      case "price4Hour":
        this.setting4Hour = setting;
        break;
      case "price8Hour":
        this.setting8Hour = setting;
        break;
      case "emailAddress":
        this.emailAddress = setting;
        break;
      case "emailPassword":
        this.emailPassword = setting;
        break;
      case "emailServer":
        this.emailServer = setting;
        break;
      case "emailPort":
        this.emailPort = setting;
        break;
      default:
        break;
    }
    this.displaySettings = true;
  }
  settingFailure(error: any) {
    this.systemStatus.description = "down";
    this.savemsg = "Settings error!";
    setTimeout(() => {
      this.savemsg = "";
    }, 4000);
    return "error";
  }

  seeSettings() {
    this.searchResultsReturned = false;
  }

  // ------------------------------------------ Get instructor and display classes ------------------------------------------ -->
  instructorLookup() {
    /* Have to show a list of Instructors and allow user to choose one */
    this.reset();
    this.showInstructorClasses = true;
    this.getInstructor(this.adminUser.email);
  }

  getInstructor(email: string) {
    this.findInstructorClasses = true;
    this._instructorService.getInstructorByEmail(email).subscribe(
      (res) => this.getInstructorSuccess(res),
      (error) => this.getInstructorFailed(error),
      () => {
        console.log("getInstructor successful!");
      }
    );
  }

  getInstructorFailed(error: any) {
    this.findInstructorClasses = false;
  }

  getInstructorSuccess(result: any) {
    this.findInstructorClasses = true;
    this.instructor = new Instructor();
    this.instructor = result;
    this._studentService
      .getClassSchedulesByInstructor(this.instructor.id)
      .subscribe(
        (res) => this.getInstructorClassesSuccess(res),
        (error) => this.getInstructorClassesFailed(error),
        () => {
          console.log('getInstructorClasses successful!');
        }
      );
  }

  getInstructorClassesFailed(error: any) {
    this.findInstructorClasses = false;
  }

  getInstructorClassesSuccess(classes: any) {
    let classesFound: ClassScheduleDto[] = [];
    for (let i = 0, len = classes.length; i < len; i++) {
      const cla = classes[i] as ClassScheduleDto;
      if (cla.startTime != null) {
        cla.startTime = this.formatTime(cla.startTime);
        cla.startDateTime = this.formatDate(cla.startDateTime);
        classesFound.push(cla);
      }
    }
    this.instructorClasses = classesFound;
    this.classResultsFound = this.instructorClasses.length > 0;
    this.findInstructorClasses = false;
    this.showInstructorClasses = true;
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  // ------------------------------------------ Student Search ------------------------------------------ -->

  studentLookup() {
    this.reset();
    this.doStudentSearch = true;
  }

  lookupStudent(searchit: NgForm) {
    if (this.searchString != null && this.searchString > "") {
      this.displaySettings = false;
      this.searching = true;
      this._studentService.studentSearch(this.searchString).subscribe(
        (res) => this.searchSuccessful(res),
        (error) => this.searchFailed(error),
        () => {
          console.log("Search successful!");
        }
      );
    } else {
      this.searchmsg =
        "Please enter Name, Address, Phone, Zip, or Email, or portions of these. Multiple values can be entered, separated by commas.";
      setTimeout(() => {
        this.searchmsg = "";
      }, 6000);
    }
  }

  searchSuccessful(res: any) {
    this.studentsToList(res);
    this.searching = false;
    this.searchResultsReturned = true;

    this.currentPageNumber = 1;
    this.displayResults = this.searchResults.slice(
      (this.currentPageNumber - 1) * this.namesPerPage,
      this.currentPageNumber * this.namesPerPage
    );
    this.totalPages = Math.ceil(this.searchResults.length / this.namesPerPage);
    this.setPages();
  }

  searchFailed(res: any) {
    this.searchResultsReturned = false;
    this.resultsFound = false;
    this.searching = false;
  }

  setPage(page: number) {
    this.currentPageNumber = page;
    this.displayResults = this.searchResults.slice(
      (this.currentPageNumber - 1) * this.namesPerPage,
      this.currentPageNumber * this.namesPerPage
    );
    this.setPages();
  }

  setAdminPage(page: number) {
    this.currentPageNumber = page;
    this.displayAdminResults = this.adminResults.slice(
      (this.currentPageNumber - 1) * this.namesPerPage,
      this.currentPageNumber * this.namesPerPage
    );
    this.setPages();
  }

  setPages() {
    let half = 3;
    let whole = half + half + 1;
    let startpage =
      this.currentPageNumber < half + 1 ? 1 : this.currentPageNumber - half;
    let endpage = startpage + whole;
    if (endpage > this.totalPages) {
      endpage = this.totalPages + 1;
      startpage = endpage < whole + 1 ? 1 : endpage - (whole + 1);
    }
    this.pages = [];
    for (let i = startpage; i < endpage; i++) {
      const apage = { id: i };
      this.pages.push(apage);
    }
  }

  addNewStudent() {
    this._dataService.setCurrentStudent(null);
    this._router.navigate(["new-student-registration"]);
  }

  editStudent() {
    let updateUser: CreateLogin = new CreateLogin();
    updateUser.firstName = this.student.firstName;
    updateUser.middleName = this.student.middleName;
    updateUser.lastName = this.student.lastName;
    updateUser.email = this.student.email;
    updateUser.roleId = this._userService.roleStudent;
    updateUser.id = this.student.id;
    const roleId = this._dataService.getRoleId();
    this._dataService.setCurrentUser(updateUser);
    this._dataService.setRoleId(roleId);
    this._router.navigate(["new-student-registration"]);
  }

  // ------------------------------------------ Classes for selected student ------------------------------------------ -->
  goToStudentInfo(student: AdminStudentSearchResult) {
    this._dataService.setStudentSelected(student);
    this.selectedStudent = student;
    this.doStudentSearch = false;
    this.readLocationList = false;
    const gotstudent = this._studentService
      .getStudentByLogin(this.selectedStudent.id, null)
      .subscribe(
        (res) => this.getStudentSuccsessful(res),
        (error) => this.getStudentFailed(error),
        () => console.log("Get Student Complete!")
      );
  }

  getStudentFailed(error: any) {}

  getStudentSuccsessful(result: any) {
    let studentPost: StudentGet = result as StudentGet;
    this.student = new StudentGet();
    this.student = studentPost;

    this._dataService.setCurrentStudent(this.student);
    this._studentService
      .getStudentClasses(this.student.id) // .studentLoginId)
      .subscribe(
        (classes) => this.getClassesSuccess(classes),
        (error) => this.getClassesFailed(error),
        () => console.log("Completed!")
      ); // comment
  }

  getClassesSuccess(classes: any) {
    this.retrieveStudent();
    let classesFound: StudentClassDto[] = [];
    for (let i = 0, len = classes.length; i < len; i++) {
      const cla = classes[i] as StudentClassDto;
      cla.classSchedule.startDateTime = this.formatDate(
        cla.classSchedule.startDateTime
      );
      classesFound.push(cla);
    }
    this.studentClasses = classesFound;
    this.classResultsFound = this.studentClasses.length > 0;
    this.showStdentClasses = true;
  }

  getClassesFailed(error: any) {
    this.classResultsFound = false;
    console.log("Failed!");
  }

  retrieveStudent() {
    const student = this._dataService.getStudentSelected();
    if (student !== null) {
      this.selectedStudent = student.student;
    } else {
      this.selectedStudent = new AdminStudentSearchResult();
    }
  }

  // ------------------------------------------ Remove student from class ------------------------------------------ -->

  selectClass(selectedClass: StudentClassDto) {
    this._dataService.setSelectedClassId(selectedClass.id);
    this.classTypeId = selectedClass.classSchedule.classMaster.classTypeId;
    this._dataService.setDistanceType("2");
    this._dataService.setClassTypeId(this.classTypeId);
    this._dataService.setClassChkNo(selectedClass.chkNo);
    this._dataService.setClassAmount(selectedClass.amount);
    this.retrieveStudent();
    const today = new Date().toISOString().split("T")[0];
    let newDate = new Date(selectedClass.classSchedule.startDateTime)
      .toISOString()
      .split("T")[0];
    if (newDate < today) {
      alert(
        `Cannot remove ${this.selectedStudent.formattedName} from a class that is in the past.`
      );
    } else {
      this.displayModal = "block";
    }
  }

  onModalClose() {
    this.displayModal = "none";
  }

  removeStudentClass() {
    this.enrollNew = false;
    this.removeStudentFromClass();
  }

  removeAndEnroll() {
    this.enrollNew = true;
    this.removeStudentFromClass();
  }

  removeStudentFromClass() {
    this.displayModal = "none";
    this.retrieveStudent();
    // this.studentClasses = null;
    const aclass = this._dataService.getSelectedClassId();
    //    this.deleteStudentClassSuccess('response'); // THIS LINE IS FOR TESTING ONLY
    this.classTypeId = this._dataService.getClassTypeId();
    const rate =
      this.classTypeId == "1"
        ? this.setting8Hour.description
        : this.setting4Hour.description;
    this._studentService
      .deleteStudentClass(this.selectedStudent.id, aclass, rate)
      .subscribe(
        (resp) => this.deleteStudentClassSuccess(resp),
        (error) => this.deleteStudentClassFailed(error),
        () => console.log("Completed!")
      ); // comment
  }

  deleteStudentClassSuccess(resp: any) {
    this.retrieveStudent();
    alert(
      `${this.selectedStudent.formattedName} has been removed from the selected Class.`
    );
    if (!this.enrollNew) {
      this.goToStudentInfo(this.selectedStudent);
    } else {
      this.listNewClasses();
    }
  }
  deleteStudentClassFailed(error: any) {
    this.enrollNew = false;
  }

  // ------------------------------------------ Enroll student in new  class ------------------------------------------ -->

  listNewClasses() {
    if (
      this.student.address.latitude != null &&
      this.student.address.latitude != "0" &&
      this.student.address.longitude != null &&
      this.student.address.longitude != "0"
    ) {
      this.getClasses();
    } else {
      this.fullAddress = true;
      this.getGeocode();
    }
  }

  getGeocode() {
    let address = "";
    if (this.fullAddress) {
      address =
        this.student.address.address1 +
        ", " +
        this.student.address.city +
        ", " +
        this.student.address.state.abbreviation +
        " ";
    }
    address +=
      (this.student.address.zipCode + "00000").substring(0, 5) + " USA";
    this._locationService.getGeocodeFromAddress(address).subscribe(
      (res) => this.getStudentGeocodeSuccess(res),
      (error) => this.getStudentGeocodeFailed(error),
      () => console.log("Get Geocode Complete!")
    );
  }

  getStudentGeocodeFailed(error: any) {}

  getStudentGeocodeSuccess(result: any) {
    const values = result;
    const res = values.results;
    if (res[0] != null && res[0].locations != null) {
      const loc = res[0].locations;
      if (loc[0] != null && loc[0].displayLatLng != null) {
        const displatlng = loc[0].displayLatLng;
        this.selectedStudent.address.latitude = displatlng.lat;
        this.selectedStudent.address.longitude = displatlng.lng;
        // If geocode is out of bounds, try again without address line (zip only)
        if (this.fullAddress && +this.student.address.longitude < -100) {
          this.fullAddress = false;
          this.getGeocode();
        } else {
          this._studentService
            .UpdateStudentLatLong(
              this.selectedStudent.id,
              displatlng.lat,
              displatlng.lng
            )
            .subscribe(
              (res) => this.saveStudentSuccess(res),
              (error) => this.saveStudentFailed(error),
              () => console.log("Student Lat,Long Updated!")
            );
        }
      }
    }
  }

  saveStudentFailed(error: any) {}

  saveStudentSuccess(result: any) {
    this.getClasses();
  }

  getClasses() {
    // this.retrieveStudent();
    this.readLocationList = true;
    this.showStdentClasses = false;
    const classTypeId = this._dataService.getClassTypeId();
    this.retrieveStudent();
    let distanceType = this._dataService.getDistanceType();
    this._classService
      .getLocations(classTypeId, this.selectedStudent.id, distanceType)
      .subscribe(
        (res) => this.getLocationsSuccsessful(res),
        (error) => this.getLocationsFailed(error),
        () => console.log("Get Locations Complete!")
      );
  }

  getLocationsSuccsessful(result: any) {
    this.readLocationList = false;
    this.showLocationList = true;
    const locations: Location[] = [];
    for (let i = 0, len = result.length; i < len; i++) {
      const loc = result[i] as Location;
      loc.address.formattedAddress = this.formataddressGet(loc.address);
      locations.push(loc);
    }
    this.loading = false;
    locations.sort(function (a, b) {
      return a.distanceToStudent - b.distanceToStudent;
    });

    this.locations = locations;
  }

  getLocationsFailed(error: any) {
    this.readLocationList = false;
  }

  register(classSchedule: ClassSchedule) {
    this._dataService.setSelectedClassSchedule(classSchedule);
    this.retrieveStudent();
    const classTypeId = this._dataService.getClassTypeId();
    const rate =
      classTypeId == "1"
        ? this.setting8Hour.description
        : this.setting4Hour.description;
    const chkno = this._dataService.getClassChkNo();
    const amount = this._dataService.getClassAmount();
    this._dataService.setClassChkNo("");
    this._dataService.setClassAmount("0.00");
    this._studentService
      .addStudentClass(this.selectedStudent.id, classSchedule.id, rate, chkno) // amount or rate?
      .subscribe(
        (res) => this.addStudentClassSuccessful(res),
        (error) => this.addStudentClassFailed(error),
        () => console.log("addStudentClass Saved!")
      );
  }

  addStudentClassFailed(errors: any) {
    const i = 0;
  }

  addStudentClassSuccessful(result: any) {
    const classSchedule = this._dataService.getSelectedClassSchedule()
      .classSchedule;
    this._dataService.setSelectedClassSchedule(classSchedule);
    const gotClassMaster = this._classMasterService
      .getClassMaster(classSchedule.classMasterId)
      .subscribe(
        (res) => this.getClassMasterSuccsessful(res),
        (error) => this.getClassMasterFailed(error),
        () => console.log("Get Class Master Complete!")
      );
  }

  getClassMasterFailed(error: any) {
    this.showLocationList = false;
    this.retrieveStudent();
    alert(
      `${this.selectedStudent.formattedName} has been enrolled in the selected class.`
    );
    this.goToStudentInfo(this.selectedStudent);
  }

  getClassMasterSuccsessful(result: any) {
    this.showLocationList = false;
    this.retrieveStudent();
    const classMaster = result as ClassMaster;
    alert(
      `${this.selectedStudent.formattedName} has been enrolled in ${classMaster.description}.`
    );
    this.goToStudentInfo(this.selectedStudent);
  }

  // ------------------------------------------ Display students in a claass ------------------------------------------ -->

  selectInstructorClass(selectedClass: ClassScheduleDto) {
    this._dataService.setSelectedClassId(selectedClass.id);
    this.classSelected = selectedClass;
    this.showInstructorClasses = false;
    this.findStudentsInClass = true;
    this._studentService.getStudentsInClass(selectedClass.id).subscribe(
      (resp) => this.getStudentsSuccess(resp),
      (error) => this.getStudentsFailed(error),
      () => console.log("Completed!")
    ); // comment
  }

  getStudentsSuccess(res: any) {
    this.studentsToList(res);
    this.studentsInClass = true;
    this.findStudentsInClass = false;
    this.showInstructorClasses = false;
  }
  getStudentsFailed(error: any) {
    this.enrollNew = false;
    this.findStudentsInClass = false;
  }

  // ------------------------------------------ display admin list ------------------------------------------ -->

  adminList() {
    this.newAdmin = new Mhsrcuser();
    this.newAdmin.roleId = 2;
    this.saving = false;
    this.msg = "";
    this.studentsInClass = false;
    this.findStudentsInClass = false;
    this.showInstructorClasses = false;
    this.findInstructorClasses = false;
    this.doStudentSearch = false;
    this.showAdmins = true;
    this.doAdminSearch = true;
    this.editAdmin = false;
    this.createAdmin = false;
    this._userService.GetAdminUsers().subscribe(
      (resp) => this.getAdminUsersSuccess(resp),
      (error) => this.getAdminUsersFailed(error),
      () => console.log("Completed!")
    ); // comment}
  }

  getAdminUsersSuccess(res: any) {
    let admins: Mhsrcuser[] = [];
    for (let i = 0, len = res.length; i < len; i++) {
      const adm = res[i] as Mhsrcuser;
      admins.push(adm);
    }
    this.adminResultsFound = admins.length > 0;
    this.adminResults = admins;
    this.currentPageNumber = 1;
    this.displayAdminResults = this.adminResults.slice(
      (this.currentPageNumber - 1) * this.namesPerPage,
      this.currentPageNumber * this.namesPerPage
    );
    this.totalPages = Math.ceil(this.adminResults.length / this.namesPerPage);
    this.setPages();
  }
  getAdminUsersFailed(error: any) {
    this.adminResultsFound = false;
  }

  decodeActive(delBy: string) {
    return delBy === undefined || delBy === null ? "Yes" : "No";
  }

  decodeRole(role: string) {
    if (role == this._userService.roleStudent) {
      return "Student";
    } else if (role == this._userService.roleAdmin) {
      return "Admin";
    } else if (role == this._userService.roleInstructor) {
      return "Instructor";
    } else if (role == this._userService.roleSuper) {
      return "Super";
    } else {
      return "Unknown";
    }
  }

  goToAdminInfo(admin: Mhsrcuser) {
    // this._dataService.setAdminSelected(admin);
    this.selectedAdmin = admin;
    this.doAdminSearch = false;
    this.editAdmin = true;
    this.createAdmin = this.selectedAdmin === this.newAdmin;
    this.isActive = admin.deletedBy === undefined || admin.deletedBy === null;
    this.passwordReset = false;
    this.isAdmin = this.selectedAdmin.roleId === 2;
    this.isSuper = !this.isAdmin;
  }

  changeAdmin() {
    this.isSuper = !this.isAdmin;
  }

  changeSuper() {
    this.isAdmin = !this.isSuper;
  }

  updateSelectedAdmin(selectedAdmin: NgForm): void {
    this.saving = true;
    this._userService.GetUserByEmail(this.selectedAdmin.email).subscribe(
      (res) => this.getUserSuccess(res),
      (error1) => this.getUserFailed(error1)
    );
  }

  getUserSuccess(res: any): void {
    if (res.email != null) {
      if (res.id != this.selectedAdmin.id || this.createAdmin) {
        alert("That email address is already in use.");
        this.saving = false;
      } else {
        this.getUserFailed("Updating existing user");
      }
    } else {
      alert("This should never happen");
      this.getUserFailed("This should never happen");
    }
  }

  getUserFailed(error1: any): void {
    // form is valid and dirty - send request'
    if (!this.isActive) {
      this.selectedAdmin.password = "Inactivate";
    } else if (
      this.passwordReset ||
      this.selectedAdmin.deletedBy != null ||
      this.createAdmin
    ) {
      this.selectedAdmin.password = "password";
      this.passwordReset = true;
    }
    let updAdmin: CreateLogin = new CreateLogin();
    updAdmin.firstName = this.selectedAdmin.firstName;
    updAdmin.middleName = this.selectedAdmin.middleName;
    updAdmin.lastName = this.selectedAdmin.lastName;
    updAdmin.email = this.selectedAdmin.email;
    updAdmin.id = this.selectedAdmin.id;
    updAdmin.roleId = this.isSuper
      ? this._userService.roleSuper
      : this._userService.roleAdmin;
    updAdmin.password = this.selectedAdmin.password;

    if (this.createAdmin) {
      this._userService.sendCreateLogin(updAdmin).subscribe(
        (result) => this.updateSelectedAdminSuccessful(result),
        (error) => this.updateSelectedAdminFailed(error),
        () => {
          console.log("LoginCreated!");
        }
      );
    } else {
      this._userService.updateLoginById(updAdmin).subscribe(
        (result) => this.updateSelectedAdminSuccessful(result),
        (error) => this.updateSelectedAdminFailed(error),
        () => {
          console.log("AdminUpdated!");
        }
      );
    }
  }

  updateSelectedAdminSuccessful(result: any) {
    // this.loading = false;
    console.log(result.message);
    this.msg = result.message;
    setTimeout(() => {
      // show message for 2 seconds, then redirect back to main?
      this.msg =
        "Record updated." +
        (this.passwordReset ? " Password has been reset." : "");
      // Navigate back to the login screen
      setTimeout(() => {
        this.adminList();
      }, 4000);
    }, 4000);
  }

  updateSelectedAdminFailed(error: any) {
    // this.loading = false;
    console.log(error.message);
    this.msg = error.message;
  }

  // ------------------------------------------ return to class list ------------------------------------------ -->

  classList() {
    this.studentsInClass = false;
    this.showInstructorClasses = true;
  }

  // ------------------------------------------ shared functions ------------------------------------------ -->

  formatDate(datestring: string) {
    let adate: string = new Date(datestring).toISOString().split("T")[0];
    adate = adate.substr(5, 5) + "-" + adate.substr(0, 4);
    return adate;
  }

  formatTime(datestring: string) {
    let atime: string = datestring.split("T")[1];
    atime = atime.substr(0, 5);
    if (atime.substr(0, 2) > '12') {
      atime = (parseInt(atime.substr(0, 2), 10) - 12).toString() + ':' + atime.split(':')[1] + ' PM';
    } else if (atime.substr(0, 2) === '12') {
      atime += ' PM';
    } else {
      atime += ' AM';
    }
    return atime;
  }

  formataddressGet(address: AddressGet) {
    if (address.address2) {
      return `${address.address1}, ${address.address2}, ${address.city} ${address.state.abbreviation} ${address.zipCode}`;
    } else {
      return `${address.address1}, ${address.city} ${address.state.abbreviation} ${address.zipCode}`;
    }
  }

  formataddress(address: AddressList) {
    if (address.address2) {
      return `${address.address1}, ${address.address2}, ${address.city} ${address.state.abbreviation} ${address.zipCode}`;
    } else {
      return `${address.address1}, ${address.city} ${address.state.abbreviation} ${address.zipCode}`;
    }
  }

  studentsToList(res: any) {
    let students: StudentList[] = [];
    for (let i = 0, len = res.length; i < len; i++) {
      const stu = res[i] as StudentList;
      stu.address.formattedAddress = this.formataddress(stu.address);
      stu.formattedName =
        stu.firstName +
        " " +
        (stu.middleName == null ? "" : stu.middleName + " ") +
        stu.lastName;
      students.push(stu);
    }
    students.sort(function (a, b) {
      return a.lastName > b.lastName
        ? 1
        : a.lastName < b.lastName
        ? -1
        : a.firstName > b.firstName
        ? 1
        : a.firstName < b.firstName
        ? -1
        : 0;
    });
    this.resultsFound = students.length > 0;
    this.searchResults = students;
  }
}



// WEBPACK FOOTER //
// ./src/app/staff-registration/staff-registration.component.ts